import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  
  /**
   * Scrolls to the top of the page with smooth behavior
   */
  scrollToTop(): void {
    if (typeof window !== 'undefined') {
      // Use smooth scrolling for better UX
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      
      // Fallback for immediate scroll if smooth scrolling doesn't work
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 50);
    }
  }

  /**
   * Scrolls to a specific element by ID
   */
  scrollToElement(elementId: string): void {
    if (typeof document !== 'undefined') {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }

  /**
   * Scrolls to a specific position
   */
  scrollToPosition(x: number, y: number): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: y,
        left: x,
        behavior: 'smooth'
      });
    }
  }
}
